import './assets/main.css'
import { config } from './config'
import de from './i18n/locales/de.json'
import en from './i18n/locales/en.json'
import * as pdfjsLib from 'pdfjs-dist'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import Buefy from 'buefy'
import 'buefy/dist/css/buefy.css'

import App from './App.vue'

import { VueDatePicker } from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?url'
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker

const app = createApp(App)

const i18n = createI18n({
  legacy: false,
  locale: 'de',
  fallbackLocale: 'de',
  messages: {
    de,
    en,
  },
})

app.config.globalProperties.$apiBase = config.API_BASE_URL

app.use(Buefy)
app.use(createPinia())
app.use(i18n)
app.component('VueDatePicker', VueDatePicker)

app.mount('#app')

document.addEventListener(
  'invalid',
  (e) => {
    const el = e.target as HTMLInputElement
    if (el?.validity.valueMissing) {
      el.setCustomValidity('Bitte füllen Sie das Pflichtfeld aus.')
    }
  },
  true,
)

document.addEventListener(
  'input',
  (e) => {
    ;(e.target as HTMLInputElement)?.setCustomValidity('')
  },
  true,
)
